import { z } from 'zod'

export const approveSettlementRoundSchema = z.object({
  accountId: z.string().guid(),
  skipBalanceAdjustment: z.boolean().optional().default(false),
})

export type ApproveSettlementRoundDto = z.infer<typeof approveSettlementRoundSchema>
